module.exports = __webpack_public_path__ + "img/programOverview1.eb396822.png";